import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white" data-id="element-76" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-4xl px-5 pb-10 sm:px-6 sm:pb-14" data-id="element-77" data-mp="1o33u6h0ytshr">
        <div className="flex flex-col items-center gap-4 rounded-xl border border-success-border bg-success-soft p-5 text-center sm:flex-row sm:items-center sm:gap-5 sm:p-6 sm:text-left" data-id="element-78" data-mp="223og3m26g4fh">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-success" data-id="element-79" data-mp="19e7qew5xz1my">
            <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-80" data-mp="14gpdyvspu4a7" />
          </span>
          <div data-id="element-81" data-mp="1j5295qjzbj3n">
            <h2 className="font-display text-xl leading-tight text-ink-strong sm:text-2xl" data-id="element-82" data-mp="1j5lt1ct6whkb">
              7 días de libertad o tu dinero de vuelta
            </h2>
            <p className="mt-1.5 text-[13px] leading-relaxed text-ink sm:text-sm" data-id="element-83" data-mp="qnzr6p5d4vc1">
              Si el sistema no te ahorra al menos 5 horas de chat esta semana,
              te reembolsamos el 100%. Sin vueltas, sin formularios.
            </p>
          </div>
        </div>
      </div>
    </section>;
}